import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CoverpathUtils } from '../../../../coverpath-common/js/static/CoverpathUtils';
import { AmorphicService } from '../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Controller } from '../Controller';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { GenesysContext } from '../../../../common/js/types/CommonTypes';

@Component({
  selector: 'agent-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  isAuthenticationPathResolved: boolean = false;

  constructor(
    private router: Router,
    private amorphicService: AmorphicService,
    private windowService: WindowService,
    private activatedRoute: ActivatedRoute
  ) {
    const controller = this.amorphicService.controller as Controller;
    let agentLinkType: string;

    if (controller.customer) {
      controller.customer.setPaidSource();
      if (controller.customer.application) {
        agentLinkType = 'personalized';
        if (controller.customer.application.isAgentAssistant) {
          agentLinkType = 'agentAssisted';
        }
      } else {
        agentLinkType = 'generic';
      }

      CoverpathUtils.dataLayerPush({
        clientID: controller.customer._id,
        agentLinkType: agentLinkType,
      });
    }

    CoverpathUtils.dataLayerPush({
      environment: this.amorphicService.controller.nonProdMode ? 'development' : 'production',
      event: 'client_app-loaded',
    });
  }

  async ngOnInit() {
    const controller: any = this.amorphicService.controller;

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        CoverpathUtils.hideLoadingPage();
        CoverpathUtils.scrollToTop();
      }
    });

    if (controller) {
      await controller.resolveAuth0Data();
      this.isAuthenticationPathResolved = true;
    }
    this.preFillGenesysWidget();
  }

  preFillGenesysWidget() {
    const customer = this.amorphicService.controller.customer;
    if (typeof this.windowService.nativeWindow.Genesys === 'function') {
      this.windowService.nativeWindow.Genesys('subscribe', 'Messenger.ready', (o) => {
        this.windowService.nativeWindow.Genesys('command', 'Database.set', {
          messaging: {
            customAttributes: {
              'WP-Authenticated': customer.email ? true : false,
              'WP-Context': GenesysContext.COVERPATH_CLIENT,
              'WP-First-Name': customer.firstName,
              'WP-Last-Name': customer.lastName,
              'WP-Email': customer.email,
              'WP-Is-1851': false,
            },
          },
        });
      });
    }
  }
}
